//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useRef } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  MenuItem,
} from '@mui/material';
import {
  Add,
} from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import { Spacer } from 'components/Spacer';

// === HOOKS ===
import { useLayout } from 'pages/FileViewer/components/Panel/PanelContext';

//#endregion

//-----------------------------------------------------------------
export function MenuItemAddPanel( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { handleClose } = props;

  const theme = useTheme();

  const { getRoot, createItem } = useLayout();

  //#endregion
  
  //#region [STYLES]

  const _flex_display = { display: 'flex' };

  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick( event ) {
    //-----------------------------------------------------------------
    event.stopPropagation();
    event.preventDefault();
    
    const root = getRoot();
    if( !root ) return;

    createItem( root.id );

    handleClose();
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <MenuItem sx={{ padding: '4px' }}>
        <Styled styles={[_flex_display, { alignItems:'center'}, ]} onClick={onClick}>
          <Add /> <Spacer size={4} /> Add Panel
        </Styled>
      </MenuItem>
    )
  }

  //#endregion

  return display();
}
